import { createContext, useContext, useState } from 'react';
import { useAuth } from './AuthContext';

export const UserBookingContext = createContext();

export const UserBookingProvider = ({ children }) => {
    const { currentUser } = useAuth();
    const [userBookings, setUserBookings] = useState([]);

    const addBooking = (booking) => {
        setUserBookings(prev => [...prev, booking]);
    };

    const updateBooking = (bookingId, updates) => {
        setUserBookings(prev => 
            prev.map(booking => 
                booking.id === bookingId ? { ...booking, ...updates } : booking
            )
        );
    };

    const cancelBooking = (bookingId) => {
        setUserBookings(prev =>
            prev.map(booking =>
                booking.id === bookingId ? { ...booking, status: 'Cancelled' } : booking
            )
        );
    };

    const getUserBookings = () => {
        return userBookings.filter(booking => booking.userId === currentUser?.id);
    };

    return (
        <UserBookingContext.Provider value={{
            userBookings,
            addBooking,
            updateBooking,
            cancelBooking,
            getUserBookings
        }}>
            {children}
        </UserBookingContext.Provider>
    );
};

export const useUserBooking = () => {
    const context = useContext(UserBookingContext);
    if (!context) {
        throw new Error('useUserBooking must be used within a UserBookingProvider');
    }
    return context;
}; 